export const spaceswitchActions = {
    changeSpace,
}

function changeSpace(space) {
    return dispatch => {
        dispatch({ type: space });
    }
}